import { useContext } from 'react'
import { IConversation, StoreContextType } from '@/context/types'

const Conversations = (context: React.Context<StoreContextType | null>) => {
  const store = useContext(context) as StoreContextType

  const getConversationList = () => {
    return store.conversations.conversationList
  }
  const setConversationList = (
    conversationsList: IConversation[],
    append?: boolean,
  ) => {
    // Keep existing messages
    const existingConversationsList = store.conversations.conversationList
    const newConversationsList = conversationsList.map(conversation => {
      return {
        ...conversation,
        messages:
          existingConversationsList.find(e => e.id === conversation.id)
            ?.messages ?? [],
      }
    })

    if (append) {
      store.conversations.setConversationList(prev => [
        ...newConversationsList,
        ...prev,
      ])
    } else {
      store.conversations.setConversationList([...newConversationsList])
    }
  }

  const getSelectedConversation = () => {
    return store.selectConversation.selectedConversation
  }

  const setSelectedConversation = (conversationId: string) => {
    store.selectConversation.setSelectedConversation(conversationId)
  }

  const findConversation = (conversationId: string) => {
    const conversationsList = getConversationList()
    const conversation = conversationsList.find(
      conversation => conversation.id === conversationId,
    )

    return conversation
  }

  const getConversationState = (conversationId: string) => {
    const conversation = findConversation(conversationId)
    if (!conversation) {
      return null
    }

    return conversation?.metadata?.state
  }

  const removeConversation = (conversationId: string) => {
    const conversationList = getConversationList()
    var filteredList = conversationList.filter(
      conversation => conversation.id !== conversationId,
    )

    store.conversations.setConversationList(filteredList)
  }

  return {
    getConversationList,
    setConversationList,
    getSelectedConversation,
    setSelectedConversation,
    findConversation,
    getConversationState,
    removeConversation,
  }
}

export default Conversations
